<div class="admin-login-page">
  <div class="login-card">
    <div class="brand">
      <span class="material-symbols-outlined brand-icon">admin_panel_settings</span>
      <h1>Weddingly Admin</h1>
      <p>Platform Management Console</p>
    </div>

    <form (ngSubmit)="onLogin()" #loginForm="ngForm" class="login-form">
      <div class="form-group" [class.error]="emailInput.invalid && emailInput.touched">
        <label>Email Address</label>
        <div class="input-wrap">
          <span class="material-symbols-outlined">mail</span>
          <input type="email" name="email" [(ngModel)]="email" #emailInput="ngModel"
            required email placeholder="admin@weddingly.com" autocomplete="username">
        </div>
        <span class="err-msg" *ngIf="emailInput.invalid && emailInput.touched">Enter a valid email</span>
      </div>

      <div class="form-group" [class.error]="passInput.invalid && passInput.touched">
        <label>Password</label>
        <div class="input-wrap">
          <span class="material-symbols-outlined">lock</span>
          <input [type]="showPassword ? 'text' : 'password'" name="password" [(ngModel)]="password"
            #passInput="ngModel" required minlength="6" placeholder="••••••••" autocomplete="current-password">
          <button type="button" class="toggle-pass" (click)="showPassword = !showPassword">
            <span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
        <span class="err-msg" *ngIf="passInput.invalid && passInput.touched">Password required</span>
      </div>

      <div class="error-banner" *ngIf="loginError">
        <span class="material-symbols-outlined">error</span> {{ loginError }}
      </div>

      <button type="submit" class="btn-login" [disabled]="loginForm.invalid || loading">
        <span class="material-symbols-outlined spin" *ngIf="loading">autorenew</span>
        <span class="material-symbols-outlined" *ngIf="!loading">login</span>
        {{ loading ? 'Signing In...' : 'Sign In to Admin' }}
      </button>
    </form>

    <p class="back-link"><a routerLink="/">← Back to Main Site</a></p>
  </div>
</div>
